export default __webpack_public_path__ + "static/media/Pistol_1.f492f0c5.png";